import { FlagProvider } from '@unleash/proxy-client-react'
import type { IMutableContext } from 'unleash-proxy-client'
import { useCurrentUser } from '../hooks'
import { config } from '../shared'

type Props = {
  children?: React.ReactNode
}

export const getUnleashContext = ({
  userId,
  workspaceId,
}: {
  userId: string
  workspaceId?: string
}): IMutableContext => ({
  userId,
  ...(workspaceId ? { properties: { workspaceId } } : {}),
})

const getWorkspaceIdFromPathname = () => {
  if (typeof window === 'undefined') {
    return undefined
  }

  return window.location.pathname.match(/^\/workspaces\/([^/]+)/)?.[1]
}

export const UnleashProvider = ({ children }: Props) => {
  const { unleashProxyAppName: appName, unleashProxyClientKey: clientKey, unleashProxyUrl: url } = config
  const user = useCurrentUser()
  const workspaceId = getWorkspaceIdFromPathname()

  return (
    <FlagProvider
      config={{
        appName,
        clientKey,
        url,
        disableMetrics: true,
        context: getUnleashContext({ userId: user.email, workspaceId }),
      }}
    >
      {children}
    </FlagProvider>
  )
}
